import { render, staticRenderFns } from "./carousel_post_list.vue?vue&type=template&id=18bd1f6a&scoped=true"
import script from "./carousel_post_list.vue?vue&type=script&lang=js"
export * from "./carousel_post_list.vue?vue&type=script&lang=js"
import style0 from "./carousel_post_list.vue?vue&type=style&index=0&id=18bd1f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd1f6a",
  null
  
)

export default component.exports